<template>
  <div class="jumbotron">
    <div class="row">
      <h2>My Marketplace Alerts</h2>
    </div>
    <div class="row box-row">
      <div class="col-md-6 text-right">
        <p class="no-margin">New Coupons In Your Area</p>
      </div>
      <div class="col-md-3">
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="sms" v-model="couponAlerts">
          <label class="form-check-label" for="inlineCheckbox1">SMS</label>
        </div>
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="checkbox" id="inlineCheckbox2" value="email" v-model="couponAlerts">
          <label class="form-check-label" for="inlineCheckbox2">Email</label>
        </div>
      </div>
    </div>
    <div class="row box-row">
      <div class="col-md-6 text-right">
        <p class="no-margin">Promotions and Special Offers</p>
      </div>
      <div class="col-md-3">
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="sms" v-model="promotionAlerts">
          <label class="form-check-label" for="inlineCheckbox1">SMS</label>
        </div>
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="checkbox" id="inlineCheckbox2" value="email" v-model="promotionAlerts">
          <label class="form-check-label" for="inlineCheckbox2">Email</label>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-10 offset-md-1">
        <b-alert variant="success"
             dismissible
             :show="showDismissibleAlert"
             @dismissed="showDismissibleAlert=false">
          Data Saved
        </b-alert>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 offset-md-4">
        <button class="btn btn-primary" v-on:click="save">Save</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  data () {
    return {
      showDismissibleAlert: false
    }
  },
  computed: {
    ...mapGetters('user', [
      'getCouponAlerts',
      'getPromotionAlerts'
    ]),
    couponAlerts: {
      get () {
        return this.getCouponAlerts
      },
      set (value) {
        this.updateCouponAlerts(value)
      }
    },
    promotionAlerts: {
      get () {
        return this.getPromotionAlerts
      },
      set (value) {
        this.updatePromotionAlerts(value)
      }
    }
  },
  methods: {
    save () {
      try {
        this.putUserData()
        this.showDismissibleAlert = true
      } catch (error) {
        console.log(error)
        this.showDismissibleAlert = false
      }
    },
    ...mapActions('user', [
      'putUserData'
    ]),
    ...mapMutations('user', [
      'updateCouponAlerts',
      'updatePromotionAlerts'
    ])
  }
}
</script>

<style scoped>
.jumbotron {
  background-color: #f1f1f1 !important;
  margin-bottom: 3rem !important;
  border-radius: 25px;
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.box-row {
  padding-bottom: 1rem;
}

@media (max-width: 768px) {
  .text-right {
    text-align: left !important;
    padding-left: 1rem;
  }
}

.no-margin {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/profile/userProfile/profiles/UserAlerts.vue